import { StopProgress } from "../../../dispatch/src/StopProgress";
import { IntercompanyAssetInfo } from "../IntercompanyAssetInfo";
import { IntercompanyBrokerageInfo } from "../IntercompanyBrokerageInfo";
import { DataSource, HorizontalSpacer, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutIntercompanyDetail extends Layout {
    horizontalspaceSO: HorizontalSpacer;
    horizontalspacerPU: HorizontalSpacer;
    labelContacts: Label;
    labelDUExt: Label;
    labelDelivery: Label;
    labelDisEmail: Label;
    labelDisPhone: Label;
    labelDisUserName: Label;
    labelDispatcher: Label;
    labelEquipment: Label;
    labelO: Label;
    labelOUEmailAddress: Label;
    labelOUExt: Label;
    labelOUName: Label;
    labelOUPhone: Label;
    labelPUActArrival: Label;
    labelPUActDeparture: Label;
    labelPUActualArrival: Label;
    labelPUActualBlank: Label;
    labelPUActualDeparture: Label;
    labelPUAddress: Label;
    labelPUCityStateZip: Label;
    labelPULatestArrival: Label;
    labelPULoc: Label;
    labelPULocationName: Label;
    labelPUSched: Label;
    labelPUSchedArriveEarly: Label;
    labelPUSchedBlank: Label;
    labelPUSchedLate: Label;
    labelPUStatusValue: Label;
    labelPickup: Label;
    labelSOActArrival: Label;
    labelSOActDeparture: Label;
    labelSOActualArrival: Label;
    labelSOActualBlank: Label;
    labelSOActualDeparture: Label;
    labelSOAddress: Label;
    labelSOCityStateZip: Label;
    labelSOLatestArrival: Label;
    labelSOLocation: Label;
    labelSOLocationName: Label;
    labelSOSched: Label;
    labelSOSchedArriveEarly: Label;
    labelSOSchedBlank: Label;
    labelSOSchedLate: Label;
    labelSOStatusValue: Label;
    labelStopDetails: Label;
    layoutICAsset: IntercompanyAssetInfo;
    layoutICBrokerage: IntercompanyBrokerageInfo;
    layoutStopProgress: StopProgress;
    panelDispatcher: Panel;
    panelICContacts: Panel;
    panelICDetail: Panel;
    panelICEquip: Panel;
    panelICInfo: Panel;
    panelICStop: Panel;
    panelOperationsUser: Panel;
    panelPUActualDates: Panel;
    panelPULabel: Panel;
    panelPUSched: Panel;
    panelPUStop: Panel;
    panelSOActualDates: Panel;
    panelSOLabel: Panel;
    panelSOSched: Panel;
    panelSOStop: Panel;
    panelStopProgress: Panel;
    sourceEdiMovementOrderIc: DataSource;
    sourceEdiOrderIc: DataSource;
}
